import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import ViewOrModal from '../modals/ViewOrModal';

function PaymentHistory({
  applicationId,
  getPaymentHistoryList,
  isLoading,
  paymentHistoryList,
}) {
  const setModal = useContext(ModalContext);

  const handleViewOR = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOrModal data={data} applicationId={applicationId} />,
      title: 'View OR',
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    if (applicationId) {
      getPaymentHistoryList(applicationId);
    }
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div className="row my-3 mx-2">
            <table className="css-table table table-borderless table-sm table-striped table-hover">
              <thead className="table-header">
                <tr>
                  <td className="font-weight-bold">Status</td>
                  <td className="font-weight-bold">Period</td>
                  <td className="font-weight-bold">OR Number</td>
                  <td className="font-weight-bold">Date Paid</td>
                  <td width={110} className="font-weight-bold">
                    Action
                  </td>
                </tr>
              </thead>
              <tbody>
                {paymentHistoryList && paymentHistoryList.length <= 0 && (
                  <tr className="text-center">
                    <td className="history-color" colSpan="7">
                      No data
                    </td>
                  </tr>
                )}
                {paymentHistoryList &&
                  paymentHistoryList.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <span className="history-color">
                          {_.get(item, 'attributes.status')}
                        </span>
                      </td>
                      <td>
                        <span className="history-color">
                          {_.get(item, 'attributes.period')}
                        </span>
                      </td>
                      <td>
                        <span className="history-color">
                          {_.get(item, 'attributes.e_or_no')}
                        </span>
                      </td>
                      <td>
                        <span className="history-color">
                          {_.get(item, 'attributes.date_paid')}
                        </span>
                      </td>
                      {_.get(item, 'attributes.is_manual') !== 1 && (
                        <td>
                          <button
                            onClick={handleViewOR(item)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                          >
                            View OR
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

PaymentHistory.defaultProps = {
  applicationId: '',
};

PaymentHistory.propTypes = {
  applicationId: PropTypes.string,
  getPaymentHistoryList: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  paymentHistoryList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  paymentHistoryList: _.get(api, `${c.GET_PAYMENT_HISTORY}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PAYMENT_HISTORY) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PaymentHistory);
